module.exports = __webpack_public_path__ + "img/logo_ups.e7dcab29.png";